"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var textAlign = function textAlign(props) {
  if (props === void 0) {
    props = {};
  }

  var styles = {};

  if (props.textAlign) {
    switch (props.textAlign) {
      case 'center':
        styles['text-align'] = 'center';
        break;

      case 'right':
        styles['text-align'] = 'right';
        break;

      default:
        styles['text-align'] = 'left';
        break;
    }
  }

  return styles;
};

exports.default = textAlign;